import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
};

const PRIMARY = {
  lighter: '#D1E9FC',
  light: '#76B0F1',
  main: '#2065D1',
  dark: '#103996',
  darker: '#061B64',
  contrastText: '#fff',
  // Dark Mode Colors //'#070D1F',
  darkMode: {
    lighter: '#32598B',
    light: '#1F406D',
    main: '#0E1E38',
    dark: '#3e4244',
    darker: '#03060A',
    contrastText: '#fff',
  },
};

const SECONDARY = {
  lighter: '#D6E4FF',
  light: '#84A9FF',
  main: '#3366FF',
  dark: '#1939B7',
  darker: '#091A7A',
  contrastText: '#fff',
};

const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#1890FF',
  dark: '#0C53B7',
  darker: '#04297A',
  contrastText: '#fff',
};

const SUCCESS = {
  lighter: '#E9FCD4',
  light: '#AAF27F',
  main: '#54D62C',
  dark: '#229A16',
  darker: '#08660D',
  contrastText: GREY[800],
};

const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#FFC107',
  dark: '#B78103',
  darker: '#7A4F01',
  contrastText: GREY[800],
};

const ERROR = {
  lighter: '#FFE7D9',
  light: '#FFA48D',
  main: '#FF4842',
  dark: '#B72136',
  darker: '#7A0C2E',
  contrastText: '#fff',
};

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: alpha(GREY[500], 0.24),
  text: {
    primary: GREY[200],
    secondary: GREY[400],
    disabled: GREY[500],
  },
  background: {
    paper: GREY[800],
    default: GREY[900],
    neutral: GREY[700],
  },
  // Define dark mode action colors, hover, selected, etc.
  action: {
    active: GREY[200], // Define dark mode active action color
    hover: alpha(GREY[200], 0.08), // Define dark mode hover action color with opacity
    selected: alpha(GREY[200], 0.16), // Define dark mode selected action color with opacity
    disabled: alpha(GREY[200], 0.8), // Define dark mode disabled action color with opacity
    disabledBackground: alpha(GREY[200], 0.24), // Define dark mode disabled background color with opacity
    focus: alpha(GREY[200], 0.24), // Define dark mode focus action color with opacity
    hoverOpacity: 0.08, // Define dark mode hover opacity
    disabledOpacity: 0.48, // Define dark mode disabled opacity
  },
  darkMode: {
    primary: PRIMARY.darkMode,
    secondary: SECONDARY.darkMode,
  },
};

export default palette;
